import React from 'react'
import * as UIcons from '@iconscout/react-unicons'
import StatCard from 'components/DetailWidgets/StatCard'

export default function TransactionStats({ stats }) {
  return (
    <div className="grid gap-4 md:grid-cols-4 w-full">
      <StatCard
        icon={UIcons.UilWallet}
        label="Total Credit"
        value={stats.totalCredit.value}
        trend={stats.totalCredit.trend}
        tone="blue"
        compareLabel="vs last 18 days"
      />
      <StatCard
        icon={UIcons.UilExchangeAlt}
        label="Total Debits"
        value={stats.totalDebits.value}
        trend={stats.totalDebits.trend}
        tone="danger"
        compareLabel="vs last 18 days"
      />
      <StatCard
        icon={UIcons.UilExchange}
        label="Credit Account Transactions"
        value={stats.creditAccountTransactions.value}
        tone="purple"
      />
      <StatCard
        icon={UIcons.UilGift}
        label="Prize Account Transactions"
        value={stats.prizeAccountTransactions.value}
        tone="gold"
      />
    </div>
  )
}
